module.exports = __webpack_public_path__ + "static/img/image_article_021.975401c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/article_img/image_article_021.png
// module id = y26M
// module chunks = 0